var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg54(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "_003-lipstick",
    "data-name": "003-lipstick",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M47.476,9.185l-1.917-.738a17.458,17.458,0,0,1-7.171-5.16A9.061,9.061,0,0,0,24.853,2.8l-.783.82-.783-.82a9.061,9.061,0,0,0-13.536.485A17.458,17.458,0,0,1,2.58,8.448L.663,9.185a.944.944,0,0,0,.072,1.774l.06.015.026.006.057.009.031,0,.054,0L1,11H1c1.459,0,3.069,1.336,5.107,3.027.92.763,1.962,1.628,3.117,2.468a.938.938,0,1,0,1.1-1.516c-1.107-.8-2.081-1.613-3.022-2.395a32.558,32.558,0,0,0-3.013-2.321c2.815-.512,7.044-.921,10.221.35a25.139,25.139,0,0,0,9.068,1.964H23.6a25.139,25.139,0,0,0,9.068-1.964c3.468-1.388,8.192-.773,10.958-.208-.883.592-1.795,1.348-2.8,2.179-3.174,2.634-7.125,5.912-13.567,6.757a.937.937,0,1,0,.244,1.859c6.979-.915,11.338-4.532,14.521-7.173C44.07,12.333,45.68,11,47.139,11a.937.937,0,0,0,.337-1.812Zm-15.5-.315a24.326,24.326,0,0,1-7.9,1.817h-.963a24.318,24.318,0,0,1-7.9-1.817,17.946,17.946,0,0,0-7.771-.911A19.307,19.307,0,0,0,11.2,4.482,7.185,7.185,0,0,1,21.93,4.1l1.461,1.53a.938.938,0,0,0,1.356,0L26.209,4.1a7.185,7.185,0,0,1,10.733.385,19.309,19.309,0,0,0,3.9,3.577A19.1,19.1,0,0,0,31.975,8.87Z",
    transform: "translate(-0.077 0)",
    fill: "#f24462"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(23.047 19.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M246.792,208.458h-.023a.938.938,0,1,0,.007,1.875h.016a.938.938,0,1,0,0-1.875Z",
    transform: "translate(-245.834 -208.458)",
    fill: "#f24462"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(9.738 13.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M116.486,164.777v-4.134a1.877,1.877,0,0,0-1.125-1.717v-5.793a2.808,2.808,0,0,0-1.485-2.479l-3-1.607a2.813,2.813,0,0,0-4.142,2.479v7.4a1.877,1.877,0,0,0-1.125,1.717v4.134a1.878,1.878,0,0,0-1.688,1.866v13.313a2.816,2.816,0,0,0,2.813,2.812h8.628a2.816,2.816,0,0,0,2.813-2.812V166.642A1.878,1.878,0,0,0,116.486,164.777Zm-7.877-13.252h0a.938.938,0,0,1,1.381-.826l3,1.607a.936.936,0,0,1,.495.826v5.635h-4.876Zm-1.125,9.118h7.127v4.125h-7.127Zm8.815,19.313a.939.939,0,0,1-.938.937h-1.688v-7.125a.938.938,0,0,0-1.876,0v7.125h-5.064a.939.939,0,0,1-.938-.937V166.642h10.5Z",
    transform: "translate(-103.92 -148.709)",
    fill: "#f24462"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(17.616 34.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M189.521,368.275a.937.937,0,1,0,.275.663A.945.945,0,0,0,189.521,368.275Z",
    transform: "translate(-187.92 -368)",
    fill: "#f24462"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg54);
export default __webpack_public_path__ + "static/media/54.172c4304.svg";
export { ForwardRef as ReactComponent };